import { Search } from 'lucide-react';
import { useNavigate } from 'react-router';

import { CommandDialog, type GrupoComando } from '@/ui/primitives/command';

import { type GrupoNavegacao } from './tipos';

interface PaletaProps {
  aberta: boolean;
  aoMudar: (aberta: boolean) => void;
  navegacao: readonly GrupoNavegacao[];
  acoes?: readonly GrupoComando[];
}

export function PaletaComandos({ aberta, aoMudar, navegacao, acoes = [] }: PaletaProps) {
  const navegar = useNavigate();
  const grupos: GrupoComando[] = [
    ...acoes,
    {
      titulo: 'Ir para',
      itens: navegacao.flatMap((grupo) =>
        grupo.itens.map((item) => ({
          id: item.para,
          rotulo: item.rotulo,
          icone: item.icone,
          ...(item.atalho ? { atalho: item.atalho } : {}),
          aoSelecionar: () => {
            void navegar(item.para);
          },
        })),
      ),
    },
  ];
  return <CommandDialog aberto={aberta} aoMudar={aoMudar} grupos={grupos} />;
}

/** Botão da barra superior que mostra o atalho. */
export function GatilhoPaleta({ aoAbrir }: { aoAbrir: () => void }) {
  return (
    <button
      type="button"
      onClick={aoAbrir}
      className="hidden h-controle items-center gap-2 rounded-controle border border-borda bg-superficie-afundada px-3 text-sm text-texto-fraco transition-colors hover:border-borda-forte hover:text-texto-suave md:flex"
    >
      <Search className="size-4" aria-hidden />
      <span className="pr-6">Buscar ou ir para…</span>
      <kbd className="font-mono text-xs">Ctrl K</kbd>
    </button>
  );
}
